import { render, staticRenderFns } from "./MinimalisticReadinessLevel.vue?vue&type=template&id=516669f0&scoped=true"
import script from "./MinimalisticReadinessLevel.vue?vue&type=script&setup=true&lang=js"
export * from "./MinimalisticReadinessLevel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MinimalisticReadinessLevel.vue?vue&type=style&index=0&id=516669f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516669f0",
  null
  
)

export default component.exports